<template>
    <div class="page_banner_mobile">
        <div class="contact_us flex-col" :style="bannerStyle">
            <div class="text-group_108 flex-col justify-between">
                <!--
                <span class="text_8">核心业务</span>
                <span class="text_9">自研3C企业健康管理服务体系</span>
                -->
                <div class="text-wrapper_3_mobile">
                    <span class="text_9_mobile">愿景</span>
                    <span class="text_10_mobile">—致力成为全球化商业组织的健康管理专家</span>
                </div>
                <div class="text-wrapper_4_mobile">
                    <span class="text_9_mobile">使命</span>
                    <span class="text_10_mobile">—助力企业实现可持续发展</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            contactBanner: {
                type: String,
                required: true
            },
            contactBannerText: {
                type: String,
                default: '自研3C企业健康管理服务体系'
            }
        },
        data() {
            return {
                //contactBanner: require('@/assets/news/news_banner_01.png')
            };
        },
        computed: {
            bannerStyle() {
                return {
                    backgroundImage: `url(${this.contactBanner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                };
            }
        },
        methods: {

        }
    };
</script>

<style scoped lang="css">

    .page_banner_mobile {
        width: 100%;
        margin: 0 auto;
        align-items: center;
    }

    .contact_us {
        width: 100%;
        height: 230px;
        position: relative;
        display: flex;
        justify-content: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text-group_108 {
        width: 179px;
        height: 130px;
        margin-left: 40px;
        justify-content: center !important;
        gap: 4px;
    }

    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_8 {
        width: 174px;
        height: 70px;
        overflow-wrap: break-word;
        color: #FFFFFF;
        font-size: 34px;
        font-family: AlibabaPuHuiTi_3_85_Bold;
        text-align: left;
        white-space: nowrap;
        line-height: 70px;
    }

    .text_9 {
        width: 179px;
        height: 70px;
        overflow-wrap: break-word;
        font-size: 20px;
        color: #FFFFFF;
        opacity: 0.6;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 70px;
        margin-top: -10px;
    }

    .text-wrapper_3_mobile {
        width: 611px;
        height: 34px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_85_Bold;
        text-align: left;
        white-space: nowrap;
        line-height: 34px;
        display: flex;
        margin: 1px 0 0 0;
        align-items: center; /* 强制垂直居中 */
        height: 34px;

    }
    .text_9_mobile {
        font-family: AlibabaPuHuiTi_3_85_Bold;
        font-size: 20px;
        color: #008683;
        line-height: 34px;
        text-align: left;
        font-style: normal;
    }

    .text_10_mobile {
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 34px;
    }

    .text-wrapper_4_mobile {
        width: 405px;
        height: 34px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        text-align: left;
        white-space: nowrap;
        line-height: 34px;
        margin: 13px 0 0 0;
    }

    .text_9_mobile {
        font-family: AlibabaPuHuiTi_3_85_Bold;
        font-size: 20px;
        color: #008683;
        line-height: 34px;
        text-align: left;
        font-style: normal;
    }

    .text_10_mobile {
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 34px;
    }


    /* 中等屏幕样式 */
    @media (max-width: 480px) {
        .contact_us {
            /*height: 25vh;*/
            height: 115px;
            width: 100%;
        }

        .text-group_108 {
            width: 80%; /* 根据需要调整宽度 */
            margin-left: 20px; /* 调整左边距以适应小屏幕 */
        }

        .text_8 {
            font-size: 26px;
        }
        .text_9 {
            font-size: 20px;
        }
        .text_9_mobile {
            font-size: 3.5vw;
            height: 30px;
            line-height: 37px;
        }
        .text_10_mobile {
            font-size: 3vw;
            height: 30px;
            line-height: 37px;
        }
        .text-wrapper_4_mobile {
            margin: -6px 0 0 0;
        }
    }

    /* 小屏幕样式（屏幕宽度小于等于750px） */
    @media (min-width: 481px) and (max-width: 700px) {
        .contact_us {
            height: 28vh;
            width: 100%;
        }

        .text-group_108 {
            width: 80%; /* 根据需要调整宽度 */
            margin-left: 20px; /* 调整左边距以适应小屏幕 */
        }

        .text_8 {
            font-size: 4vw; /* 使用相对字体大小 */
            height: 30px;
            line-height: 37px;
        }

        .text_9 {
            font-size: 3vw; /* 使用相对字体大小 */
            height: 37px;
            line-height: 37px;
        }

        .text_8 {
            margin-bottom: 10px; /* 增加间距以改善可读性 */
        }
        .text_9_mobile {
            font-size: 4vw;
            height: 30px;
            line-height: 37px;
        }
        .text_10_mobile {
            font-size: 3.5vw;
            height: 30px;
            line-height: 37px;
        }
    }
</style>
